import Vue from 'vue';
import Vuex from 'vuex'; 
import axios from 'axios';
//import services from './services';
Vue.use(Vuex);

const state = {
  //services,
  menus: [],
  user: null,
  cliente: null,
  clienteid: null,
  vercm: null,
  rol: null,
  authenticated: false,
  signalr: null,
  token: null,
  apikey: null,
  urlBase: `https://gasco.smartoffer.cl/api/`//`http://64.227.13.230/api/` http://localhost:3000/api/  https://gasco.smartoffer.cl/api/ https://localhost:5001/api/
};
const mutations = {
  SAVE_TOKEN (state, data) {
    localStorage.setItem('jwt', data);
    state.token = data;
    state.authenticated = true;
    var signalconn = Vue.prototype.isConnected();
    if(signalconn == null)
    {
      Vue.prototype.startSignalR(localStorage.getItem("jwt")) ;
    }
  },
   SAVE_APIKEY (state, data) {
    localStorage.setItem('apikey', data);
    state.apikey = data;
    
  },

  SET_CURRENT_USER (state, data) {
    localStorage.setItem('user', data);
    state.user = data;
  },
  SAVE_SIGNALR (state, data) {
     
    state.signalr = data;
  },
  SET_CURRENT_CLIENTE (state, data) {
    localStorage.setItem('cliente', data);
    state.cliente = data;
  },
  SET_CURRENT_VERCM (state, data) {
    localStorage.setItem('tieneCM', data);
    state.vercm = data;
  },
  SET_ROL (state, data) {
    localStorage.setItem('rol', data);
    state.rol = data;
  },
  SET_CURRENT_CLIENTEID (state, data) {
    //localStorage.setItem('clienteid', data);
    state.clienteid = data;
  },
  LOGOUT (state) {
    localStorage.removeItem('jwt');
    localStorage.removeItem('apikey');
    state.token = null;
    state.authenticated = false;
    state.user = null;
    state.vercm = null;
    state.rol = null;
    state.notes = [];
    state.apikey = null;
  },
  
};
const actions = {
  
  setSignalR ({
    commit
  }, id) {
    commit('SAVE_SIGNALR', id);
  },

  saveToken ({
    commit
  }, token) {
    commit('SAVE_TOKEN', token);
  },
saveApiKey ({
    commit
  }, apikey) {
    commit('SAVE_APIKEY', apikey);
  },
  setCurrentUser ({
    commit
  }, user) {
    commit('SET_CURRENT_USER', user);
  },

  setCurrentCliente ({
    commit
  }, cliente) {
    commit('SET_CURRENT_CLIENTE', cliente);
  },

  setCurrentClienteId ({
    commit
  }, clienteid) {
    commit('SET_CURRENT_CLIENTEID', clienteid);
  },
  setCurrentVercm ({
    commit
  }, vercm) {
    commit('SET_CURRENT_VERCM', vercm);
  },
  setRol ({
    commit
  }, rol) {
    commit('SET_ROL', rol);
  },
  logout ({
    commit
  }) {
    return new Promise((resolve, reject) => {
      localStorage.removeItem('jwt');
    }, error => console.log(error));
  },

  refreshToken ({
    commit
  }) {
    return new Promise((resolve, reject) => {
      // eslint-disable-next-line
        
      localStorage.removeItem('jwt');
      let data = localStorage.getItem('refreshToken');
      axios.post(state.urlBase + 'account/refreshtoken', {
        token: data
      })
        .then(function (response) {
          
          resolve(response);
        })
        .catch(function (error) {
          console.log(error);
          reject(error);
        });
    }, error => console.log(error));
      
  }
};
const getters = {
  currentUser: (state) => {
     let data = state.user;//localStorage.getItem('user');
     if(data === '' || data === undefined || data === null)
     {
       data = localStorage.getItem('user');
     }
    return data;//state.user;
  },
  getSignalR: (state) => {
    return state.signalr;
  },
  authenticated: (state) => {
    return state.authenticated;
  },
  currentCliente: (state) => {
    debugger;
    let data = state.cliente;//localStorage.getItem('cliente');
    if(data === '' || data === undefined || data === null)
     {
       data = localStorage.getItem('cliente');
     }
    return data;//state.user;

  },
  currentVercm: (state) => {
    debugger;
    let data = state.vercm;//localStorage.getItem('cliente');
    if(data === '' || data === undefined || data === null)
     {
       data = localStorage.getItem('tieneCM');
     }
    return data;//state.user;

  },
  currentRol: (state) => {
    debugger;
    let data = state.rol;//localStorage.getItem('cliente');
    if(data === '' || data === undefined || data === null)
     {
       data = localStorage.getItem('rol');
     }
    return data;//state.user;

  },
  currentClienteId: (state) => {

    //let data = localStorage.getItem('clienteid');
    return state.clienteid;

  }
};

export default new Vuex.Store({
  state,
  mutations,
  actions,
  getters
});
